<template>
  <div style="padding: 0 15px;" class="hand-book" >
    <span class="icon font_family icon-bangzhu" style="font-size: 28px;margin-right: 5px"></span>
  </div>
</template>

<script>
export default {
  name: 'MallCourse',

  methods: {

  }
}
</script>

<style scoped>
.hand-book {
  display: inline-block;
  vertical-align: middle;
  width: 40px;
  height: 40px;
  line-height: 10px;
}

.hand-book.is-active {
  transform: rotate(180deg);
}
</style>



// WEBPACK FOOTER //
// src/components/comm/HandBook/index.vue